import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Descarga y Prepárate',
    desc: 'Descarga la guía y limpia tu agenda para las próximas 48 horas.'
  }, {
    num: '2',
    title: 'Configuración Expréss',
    desc: "Sigue los pasos técnicos simplificados para tener tu 'caja registradora' lista."
  }, {
    num: '3',
    title: 'Tráfico y Lanzamiento',
    desc: 'Aplica la estrategia de tráfico de guerrilla y lanza tu oferta al mundo.'
  }];
  return <section className="py-24 bg-navy-900 text-white px-4" data-id="element-77">
      <div className="max-w-5xl mx-auto" data-id="element-78">
        <div className="text-center mb-16" data-id="element-79">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-80">Cómo Funciona</h2>
          <p className="text-xl text-gray-400" data-id="element-81">
            Tres simples pasos para pasar de cero a ventas.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-82">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-1 bg-navy-700 z-0" data-id="element-83"></div>

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-84">
              <div className="w-24 h-24 rounded-full bg-electric-600 border-4 border-navy-900 flex items-center justify-center text-4xl font-bold font-heading mb-6 shadow-[0_0_30px_rgba(37,99,235,0.5)]" data-id="element-85">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-86">{step.title}</h3>
              <p className="text-gray-400 text-lg" data-id="element-87">{step.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}